/**
 * ID format tag type constants.
 * Extracted so idFormatUtils can import without pulling in @dnd-kit via IDFormatBuilder.
 */
export const TAG_TYPES = {
  LETTERS_UPPERCASE: 'letters_uppercase',
  LETTERS_LOWERCASE: 'letters_lowercase',
  LETTERS_MIXED: 'letters_mixed',
  DIGITS: 'digits',
  ALPHANUMERIC_UPPERCASE: 'alphanumeric_uppercase',
  ALPHANUMERIC_LOWERCASE: 'alphanumeric_lowercase',
  ALPHANUMERIC_MIXED: 'alphanumeric_mixed',
  HYPHEN: 'hyphen',
  CONSTANT_VALUE: 'constant_value',
  INCREMENTAL_DIGITS: 'incremental_digits',
  SITE_ID: 'site_id',
  STUDY_ID: 'study_id',
}
